import { Pipe, PipeTransform } from '@angular/core';
import { TaskStatusFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-find.dto';
import { TaskStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/task.status.type.enum';

export const taskStatusTypeOrders: Partial<Record<TaskStatusTypeEnum, number>> = {
  [TaskStatusTypeEnum.DRAFT]: 0,
  [TaskStatusTypeEnum.SCHEDULED]: 1,
  [TaskStatusTypeEnum.ON_APPROVAL]: 2,
  [TaskStatusTypeEnum.REFUSED]: 3,
  [TaskStatusTypeEnum.AGREED]: 4,
  [TaskStatusTypeEnum.PAID]: 5,
  [TaskStatusTypeEnum.UNDERPAYMENT]: 6,
  [TaskStatusTypeEnum.OVERPAYMENT]: 7
};

@Pipe({
  standalone: true,
  name: 'sortTaskStatusByOrder'
})
export class SortTaskStatusByOrderPipe implements PipeTransform {
  public transform(statuses: TaskStatusFindInterface[]): TaskStatusFindInterface[] {
    return [...statuses].sort((a, b) => {
      const orderA = taskStatusTypeOrders[a.type];
      const orderB = taskStatusTypeOrders[b.type];

      return orderA - orderB;
    });
  }
}
